import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { required } from "../../../util/validators";
import { ImportModal } from "../../components/ImportModal";
import { AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";

export const ImportCodesModal = ({ onImport, policyId, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      policyCoverage: {
        policyId: values.policyId,
        labId: values.labId,
      },
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post("/admin/policy_coverages/import.json", snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return (
    <ImportModal
      onImport={handleImport}
      initialValues={{ policyId }}
      title="Import Codes"
      exampleDownloadPath="/admin/policy_coverages/example"
      buttonProps={rest}
    >
      {() => (
        <>
          <Field component={TextInput} name="policyId" type="hidden" required validate={required} />
          <Field component={AdminOptionableInput} resource="labs" label="Lab" name="labId" />
        </>
      )}
    </ImportModal>
  );
};
